var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountryflag3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10579_209358)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7694,
    height: 16.7694,
    transform: "translate(0.929688 0.0644531)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31438 16.8338C13.9451 16.8338 17.6991 13.0799 17.6991 8.44915C17.6991 3.81841 13.9451 0.0644531 9.31438 0.0644531C4.68364 0.0644531 0.929688 3.81841 0.929688 8.44915C0.929688 13.0799 4.68364 16.8338 9.31438 16.8338Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31401 3.3457L9.5855 4.18119H10.4639L9.75322 4.69754L10.0247 5.53303L9.31401 5.01665L8.60328 5.53303L8.87476 4.69754L8.16406 4.18119H9.04252L9.31401 3.3457Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70667 4.83951L6.48946 5.23831L7.11061 4.61719L6.97315 5.48481L7.75591 5.88364L6.88825 6.02107L6.75082 6.88875L6.35199 6.10599L5.48438 6.24346L6.10553 5.6223L5.70667 4.83951Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21094 8.44878L5.04643 8.17729V7.29883L5.56274 8.00956L6.39826 7.73807L5.88185 8.44878L6.39826 9.15948L5.56274 8.88802L5.04643 9.59872V8.72026L4.21094 8.44878Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70667 12.059L6.1055 11.2762L5.48438 10.655L6.35203 10.7925L6.75079 10.0098L6.88825 10.8774L7.75587 11.0148L6.97321 11.4137L7.11061 12.2813L6.48946 11.6601L5.70667 12.059Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31401 13.5544L9.04249 12.719H8.16406L8.8748 12.2026L8.60328 11.3672L9.31401 11.8835L10.0247 11.3672L9.75322 12.2026L10.4639 12.719H9.58546L9.31401 13.5544Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9242 12.059L12.1414 11.6602L11.5202 12.2813L11.6577 11.4136L10.875 11.0148L11.7426 10.8774L11.88 10.0098L12.2788 10.7925L13.1465 10.655L12.5253 11.2762L12.9242 12.059Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4177 8.44878L13.5822 8.72026V9.59872L13.0659 8.88799L12.2305 9.15948L12.7468 8.44878L12.2305 7.73807L13.0659 8.00956L13.5822 7.29883V8.17732L14.4177 8.44878Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9242 4.83948L12.5253 5.62227L13.1465 6.24343L12.2788 6.10593L11.88 6.88869L11.7426 6.02103L10.875 5.88357L11.6577 5.48477L11.5202 4.61719L12.1414 5.23831L12.9242 4.83948Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10579_209358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7694,
    height: 16.7694,
    fill: "white",
    transform: "translate(0.929688 0.0644531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryflag3);
export default __webpack_public_path__ + "static/media/Countryflag3.95ffa9642c49683a2743596228d25bdf.svg";
export { ForwardRef as ReactComponent };